import React from 'react';
import { Button, Dropdown, DropdownToggle, DropdownMenu } from 'reactstrap';
import moment from 'moment';
import { FormattedMessage } from 'react-intl';
import StatisticDateFilterDatePicker from '@components/Statistics/StatisticDateFilterDatePicker';

const today = moment();
const yesterday = moment().subtract(1, 'day');

const presets = [
  {
    id: 'today',
    start: today,
    end: today,
  },
  {
    id: 'yesterday',
    start: yesterday,
    end: yesterday,
  },
  {
    id: 'week',
    start: moment().startOf('w'),
    end: today,
  },
  {
    id: 'last-week',
    start: moment()
      .startOf('w')
      .subtract(1, 'w'),
    end: moment()
      .endOf('w')
      .subtract(7, 'd'),
  },
  {
    id: 'last-7-days',
    start: moment().subtract(1, 'w'),
    end: today,
  },
  {
    id: 'month',
    start: moment().startOf('M'),
    end: today,
  },
  {
    id: 'last-30-days',
    start: moment().subtract(1, 'M'),
    end: today,
  },
  {
    id: 'last-month',
    start: moment()
      .startOf('M')
      .subtract(1, 'M'),
    end: moment()
      .startOf('M')
      .subtract(1, 'd'),
  },
  {
    id: 'this-year',
    start: moment().startOf('y'),
    end: today,
  },
  {
    id: 'whole-year',
    start: moment().subtract(1, 'y'),
    end: today,
  },
];

const StatisticsDateFilter = ({
  data: { startDate, endDate, open, startDateLabel, endDateLabel },
  toggle,
  onDateChange,
  onDateApply,
  renderDatePresets,
}) => {
  return (
    <Dropdown isOpen={open} toggle={toggle} tag="span">
      <DropdownToggle onClick={toggle} data-toggle="dropdown" aria-expanded={open} tag="span">
        <div className="date-picker-range " id="filter_date_container">
          <div className="date-label-container">
            <Button
              size="sm"
              color="light"
              active={open}
              id="filter_date_start"
              onClick={toggle}
              outline
              className="btn-toggler"
            >
              {startDateLabel}-{endDateLabel}
              <i className="dropdown-toggle" />
            </Button>
          </div>
        </div>
      </DropdownToggle>
      <DropdownMenu placement="bottom" className="filter-popover filter-popover_datepicker">
        <StatisticDateFilterDatePicker
          onChange={onDateChange}
          date={startDate}
          startDate={startDate}
          endDate={endDate}
          value="startDate"
        />

        <StatisticDateFilterDatePicker
          onChange={onDateChange}
          date={endDate}
          startDate={startDate}
          endDate={endDate}
          value="endDate"
        />
        <div className="filter-datepicker-presets">
          <ul className="filter-datepicker-presets-list">
            <li>
              <span className="filter-datepicker-presets-title">
                <FormattedMessage id="statistics.filters.presets.title" defaultMessage="Period" />
              </span>
            </li>

            {renderDatePresets(presets)}
          </ul>
          <Button size="sm" color="primary" onClick={onDateApply}>
            <FormattedMessage defaultMessage="Apply" id="statistics.filters.apply" />
          </Button>
        </div>
      </DropdownMenu>
    </Dropdown>
  );
};

export default StatisticsDateFilter;
